import { render } from "./BasicLayout.vue?vue&type=template&id=9df026e4"
import script from "./BasicLayout.vue?vue&type=script&lang=js"
export * from "./BasicLayout.vue?vue&type=script&lang=js"
script.render = render

export default script